import { LitElement, html, svg } from 'lit';

export class IconPlayhouse24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Klatrestativ</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.25 23V4.5M9.75 23V4.5M.936 5.506 6 1l5.063 4.506M14 11v7M19 11v7M2.25 16h7.5M12.5 18h8M2.25 11H21.5a1.5 1.5 0 0 1 1.5 1.5V23M2.25 6h7.5M2.25 21h7.5"></path></svg>`; }
}
if (!customElements.get('f-icon-playhouse24', IconPlayhouse24)) {
  customElements.define('f-icon-playhouse24', IconPlayhouse24);
}